type UploadedImageLike = {
  name?: string;
  asset?: { name?: string };
  asset_id?: string;
  assetId?: string;
  description?: string;
  folder_type?: string;
};

const escapeXml = (value: string): string =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');

export const buildMessageWithAttachments = (
  message: string,
  uploadedImages?: UploadedImageLike[]
): string => {
  let messageString = message.trim();

  if (uploadedImages && uploadedImages.length > 0) {
    const filesXml = uploadedImages
      .map((image) => {
        const name = image?.name || image?.asset?.name || 'image';
        const assetId = image?.asset_id || image?.assetId || '';
        const description = image?.description || '';
        const folderType = image?.folder_type || '';
        const escapedDescription = escapeXml(description);

        return `<file name="${name}" asset_id="${assetId}" folder_type="${folderType}"><description>${escapedDescription}</description></file>`;
      })
      .join('');

    messageString += `<attachments>${filesXml}</attachments>`;
  }

  return messageString;
};
